import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import styles from "./Spinner.module.scss"

export default function Spinner() {
    return <FontAwesomeIcon className={styles.spinner} icon={faSpinnerThird} size="2x" spin={true} />
}
